import { ContentLayout } from 'components/layouts';
import { selectCurrentUserId, selectCurrentUserRole } from 'features/auth';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { ContactGantt } from '../components/ContactGantt';
import { ContactGanttActionBar } from '../components/ContactGanttActionBar';
import ganttStore from 'components/projectOverview/gantt/ganttConfig/ganttStore';
import { useState } from 'react';

export const ContactSchedule = () => {
  const { contactId } = useParams();
  const [reloadGantt, setReloadGantt] = useState(false);
  const userId = useSelector((state) => selectCurrentUserId(state));
  const userRole = useSelector((state) => selectCurrentUserRole(state));
  const id = userRole === 'contractor_contact' ? userId : contactId;

  if (id) {
    const ganttId = `contact-gantt-${id}`;
    ganttStore.createGantt(ganttId);
  }

  if (!id) {
    return null;
  } else {
    return (
      <ContentLayout header={<ContactGanttActionBar contactId={id} reloadGantt={reloadGantt} setReloadGantt={setReloadGantt} />}>
        <ContactGantt contactId={id} reloadGantt={reloadGantt} />
      </ContentLayout>
    );
  }
};
